import {
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { AxiosError } from 'axios';

type Options = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<{ errors?: string[] }>) => void;
};

/**
 * 初回ログイン未完了者への再招待メール一斉送信フック（任意発火）
 */
export const usePostClientUsersBulkLoginReminder = (threeLetterCode: string, options?: Options) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsUsersBulkLoginRemindersMutationFetcher(threeLetterCode),
    options
  );
